module.exports = __webpack_public_path__ + "img/box-cover.4a8f0c3f.svg";